export enum ClassifierDefinitionCode {
  GRANT_TYPE = 'GRANT_TYPE',
  GRANT_STATUS_SOURCE = 'GRANT_STATUS_SOURCE',
  GRANT_STATUS = 'GRANT_STATUS',
  GRADUATION_DOCUMENT_TYPE = 'GRADUATION_DOCUMENT_TYPE',
  GRANT_FILE_TYPE = 'GRANT_FILE_TYPE',
}
